export default function Header() {
    return (
        <header className="header">
            <img src="./images/MemeFace.png" alt="HeaderImage" className="header-image" />
            <h2 className="header-title">Meme Generator</h2>
            <h4 className="header-project">React Project</h4>
        </header>
    )
}